import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config.js';

// Helpers
import { closeDrawer } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

const Checkout = observer(class Checkout extends React.Component {
  constructor() {
    super();

    this.handleEventListener = this.handleEventListener.bind(this);
  }

  handleEventListener(event) {
    // Verify the origin of the message
    if (event.origin === 'https://support.smarterservices.com' || event.origin === 'https://support.dev.smarterservices.com') {
      try {
        // Parsing the received message
        const message = JSON.parse(event.data);

        if (message.type === 'checked-out') {
          this.props.refreshList({});
          closeDrawer(null, this.props.parent);
        }
      } catch (e) {
        console.error('Error parsing message:', e);
      }
    }
  }
  componentDidMount() {
    window.addEventListener('message', this.handleEventListener)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleEventListener)
  }
  render() {
    const { sessionSid, store, translation } = this.props;
    const { userData } = store.SessionStore
    const token = sessionStorage.getItem('token');

    return (
      <div className='drawer__content'>
        <header className="drawer__header">
          <div className="wrap wrap--large">
            <h1 className="drawer__title">{translation.heading}</h1>
          </div>
        </header>
        <iframe
          className='iframe--full'
          src={`${config.checkoutUrlBase}&sessionSid=${sessionSid}&proctorUserSid=${userData.sid}&token=${token}`}
        />
      </div>
    )
  }
});

export default translate('Checkout')(Checkout);


// WEBPACK FOOTER //
// ./src/app/components/Checkout/Checkout.js